import { MealPlan } from '@/lib/index';

export const DEMO_MEAL_PLAN: MealPlan = {
  store_name: "No Frills",
  week_summary: "This week's best deals are on pork ribs (40% off), chicken drumsticks, sirloin steak, and an incredible selection of fresh vegetables — garlic at $0.22, snap peas at $2.88, and cucumbers 3-for-$2.82. We've built 7 meals that keep your grocery bill under $5/serving.",
  sale_items_found: 1225,
  demo_mode: true,
  total_grocery_cost: 187.50,
  total_grocery_cost_no_spices: 148.00,
  savings_vs_regular: 52.00,
  meals: [
    {
      id: "m1",
      meal_type: "Dinner",
      day: "Monday",
      name: "Maple-Glazed Pork Ribs + Roasted Russet Potatoes",
      tagline: "Sticky, sweet, and smoky — the ribs are 40% off this week.",
      serves: 4,
      cook_time: "2 hr 30 min",
      method: "Oven",
      total_cost: 11.55,
      per_serving: 2.89,
      ingredients: [
        { name: "Pork Back Ribs (1 rack)", qty: "1 rack", price: 8.99, on_sale: true },
        { name: "Russet Potatoes (~2 lb from bag)", qty: "~2 lb", price: 0.85, on_sale: true },
        { name: "100% Pure Maple Syrup", qty: "3 tbsp", price: 0.68, on_sale: true },
        { name: "Colossal Fresh Garlic", qty: "1 head", price: 0.22, on_sale: true },
        { name: "Organic Smoked Paprika", qty: "1 tsp", price: 0.06, on_sale: true },
        { name: "Organic Garlic Powder", qty: "1 tsp", price: 0.06, on_sale: true },
        { name: "Organic Rosemary", qty: "pinch", price: 0.14, on_sale: true },
        { name: "Pantry: oil, soy sauce, vinegar, salt, pepper", qty: "—", price: 0.55, on_sale: false },
      ],
      instructions: [
        "Preheat oven to 300°F. Remove the membrane from the back of the ribs.",
        "Mix maple syrup, soy sauce, minced garlic, paprika, garlic powder, salt, and pepper into a glaze. Brush half over ribs, wrap tightly in foil, bake 2 hours.",
        "Cube potatoes, toss with oil, salt, pepper, and rosemary. Add to a separate sheet pan.",
        "After 2 hours, unwrap ribs and raise oven to 400°F. Add potatoes to the oven.",
        "Brush remaining glaze on ribs. Roast uncovered 25–30 min until caramelized and potatoes are golden.",
        "Rest ribs 5 minutes, slice between bones, and serve alongside the roasted potatoes."
      ],
      tip: "Buy the full 20 lb bag of Russets at $8.48 — they keep for weeks and you'll use them all week."
    },
    {
      id: "m2",
      meal_type: "Dinner",
      day: "Tuesday",
      name: "Sirloin Steak Stir-Fry with Snap Peas & Napa Cabbage",
      tagline: "Five on-sale vegetables in one hot wok. Ready in 20 minutes.",
      serves: 4,
      cook_time: "20 min",
      method: "Wok / Stovetop",
      total_cost: 23.10,
      per_serving: 5.78,
      ingredients: [
        { name: "Sirloin Tip Steak (~450g pkg)", qty: "~450g", price: 7.17, on_sale: true },
        { name: "Snap Peas", qty: "1 bag", price: 2.88, on_sale: true },
        { name: "Snow Peas", qty: "1 bag", price: 2.88, on_sale: true },
        { name: "Greenhouse Pepper, Orange", qty: "1", price: 2.11, on_sale: true },
        { name: "Chinese Napa Cabbage (¼ head)", qty: "¼ head", price: 0.89, on_sale: true },
        { name: "Whole Cremini Mushrooms", qty: "1 pkg", price: 4.50, on_sale: true },
        { name: "Fresh Garlic", qty: "1 head", price: 0.22, on_sale: true },
        { name: "Fresh Ginger", qty: "1 knob", price: 0.46, on_sale: true },
        { name: "Green Onion", qty: "1 bunch", price: 0.99, on_sale: true },
        { name: "Pantry: soy sauce, sesame oil, cornstarch, oil, rice", qty: "—", price: 1.00, on_sale: false },
      ],
      instructions: [
        "Slice steak thinly across the grain. Marinate in 1 tbsp soy sauce + 1 tsp cornstarch for 10 min.",
        "Heat oil in a wok over high heat until smoking. Sear steak 1 min per side. Remove and set aside.",
        "Add garlic and ginger, stir-fry 30 seconds. Add mushrooms, cook 2 min.",
        "Add peppers, snap peas, and snow peas — stir-fry 2 min. Add napa cabbage, toss 1 min.",
        "Return steak to wok. Add remaining soy sauce and sesame oil. Toss everything 1 min to coat.",
        "Garnish with green onions. Serve over steamed rice."
      ],
      tip: "Slice steak while still slightly frozen for cleaner, thinner cuts."
    },
    {
      id: "m3",
      meal_type: "Dinner",
      day: "Wednesday",
      name: "Honey-Garlic Chicken Drumsticks with Bok Choy",
      tagline: "Drumsticks at nearly 40% off — paired with on-sale bok choy.",
      serves: 4,
      cook_time: "50 min",
      method: "Oven + Stovetop",
      total_cost: 14.93,
      per_serving: 3.73,
      ingredients: [
        { name: "Chicken Drumsticks Club Pack", qty: "~1.5 kg", price: 9.09, on_sale: true },
        { name: "Fresh Garlic", qty: "1 head", price: 0.22, on_sale: true },
        { name: "Fresh Ginger", qty: "1 knob", price: 0.46, on_sale: true },
        { name: "100% Pure Maple Syrup", qty: "2 tbsp", price: 0.45, on_sale: true },
        { name: "Shanghai Bok Choy (3–4 heads)", qty: "1 bag", price: 4.06, on_sale: true },
        { name: "Montreal Chicken Seasoning", qty: "1 tsp", price: 0.10, on_sale: true },
        { name: "Pantry: soy sauce, oil, rice vinegar, salt, pepper", qty: "—", price: 0.55, on_sale: false },
      ],
      instructions: [
        "Score drumsticks with a knife. Marinate in soy sauce, maple syrup, garlic, ginger, and Montreal Chicken Seasoning for at least 30 min.",
        "Preheat oven to 425°F. Place drumsticks on a wire rack over a foil-lined tray.",
        "Bake 35–40 min, turning and basting halfway through, until skin is lacquered and internal temp is 165°F.",
        "While chicken rests, heat oil in a skillet over high heat. Halve bok choy lengthwise, place cut-side down. Cook 2 min.",
        "Flip bok choy, add a splash of water, cover 1 min until just tender. Season with soy sauce and rice vinegar.",
        "Plate drumsticks alongside bok choy and serve."
      ],
      tip: "Leftover drumsticks are excellent shredded over rice noodles with a drizzle of the pan drippings."
    },
    {
      id: "m4",
      meal_type: "Dinner",
      day: "Thursday",
      name: "Beef Stew with Russet Potatoes & Cremini Mushrooms",
      tagline: "Classic comfort food — stew meat is 27% off and every vegetable is on sale.",
      serves: 6,
      cook_time: "2 hr 20 min",
      method: "Dutch Oven",
      total_cost: 27.39,
      per_serving: 4.56,
      ingredients: [
        { name: "Beef Stew Meat (~700g pkg)", qty: "~700g", price: 12.68, on_sale: true },
        { name: "Russet Potatoes (~4 lb)", qty: "~4 lb", price: 1.70, on_sale: true },
        { name: "Whole Cremini Mushrooms", qty: "1 pkg", price: 4.50, on_sale: true },
        { name: "Chinese Red Carrot (×2)", qty: "2", price: 1.08, on_sale: true },
        { name: "Red Onion (from 3 lb bag)", qty: "1", price: 1.33, on_sale: true },
        { name: "Fresh Garlic", qty: "1 head", price: 0.22, on_sale: true },
        { name: "Diced Tomatoes (canned)", qty: "1 can", price: 1.79, on_sale: true },
        { name: "Beef Broth (×2 cans)", qty: "2 cans", price: 3.38, on_sale: true },
        { name: "Organic Thyme + Bay Leaves", qty: "pinch + 2 leaves", price: 0.26, on_sale: true },
        { name: "Pantry: flour, oil, tomato paste, salt, pepper", qty: "—", price: 0.45, on_sale: false },
      ],
      instructions: [
        "Pat beef dry, season with salt and pepper, dust lightly with flour.",
        "Heat oil in a Dutch oven over medium-high. Sear beef in batches until browned on all sides. Remove and set aside.",
        "Sauté onion and garlic until softened, 3 min. Add tomato paste, cook 1 min. Deglaze with a splash of broth.",
        "Add diced tomatoes, remaining broth, thyme, and bay leaves. Return beef. Bring to a simmer, cover, and cook on low 1 hour.",
        "Add potatoes, mushrooms, and carrots. Cook uncovered 45 min until vegetables are tender and broth thickens.",
        "Remove bay leaves. Taste and adjust seasoning. Serve with crusty bread."
      ],
      tip: "Even better the next day — make a double batch and freeze half for a future effortless dinner."
    },
    {
      id: "m5",
      meal_type: "Dinner",
      day: "Friday",
      name: "Italian Sausage & Rapini Pasta",
      tagline: "Rapini at $1.99 is a steal. Roman-style pasta in 25 minutes.",
      serves: 4,
      cook_time: "25 min",
      method: "Stovetop",
      total_cost: 16.89,
      per_serving: 4.22,
      ingredients: [
        { name: "Hot or Mild Italian Pork Sausages (4 links)", qty: "1 pack", price: 6.49, on_sale: true },
        { name: "Rapini (1 bunch)", qty: "1 bunch", price: 1.99, on_sale: true },
        { name: "Fresh Garlic", qty: "1 head", price: 0.22, on_sale: true },
        { name: "Jalapeno Pepper", qty: "1", price: 0.44, on_sale: true },
        { name: "Parmesan Shredded Cheese", qty: "1 pkg", price: 5.99, on_sale: true },
        { name: "Organic Italian Seasoning", qty: "1 tsp", price: 0.06, on_sale: true },
        { name: "Pantry: pasta 350g, olive oil, salt, chili flakes", qty: "—", price: 1.70, on_sale: false },
      ],
      instructions: [
        "Cook pasta in well-salted boiling water until al dente. Reserve 1 cup pasta water before draining.",
        "Blanch rapini in the pasta water for 2 min, transfer to an ice bath, then squeeze out moisture and roughly chop.",
        "Remove sausage from casings and crumble into a large skillet over medium-high heat. Brown 6–8 min. Remove and set aside.",
        "In the same pan, heat olive oil over medium. Add sliced garlic and jalapeno; cook until golden, about 2 min.",
        "Add rapini and toss 1 min. Return sausage. Add drained pasta and a splash of pasta water; toss vigorously to coat.",
        "Season with Italian seasoning and chili flakes. Plate and top generously with parmesan."
      ],
      tip: "Blanching the rapini first removes bitterness — don't skip this step."
    },
    {
      id: "m6",
      meal_type: "Lunch",
      day: "Wednesday",
      name: "Mango-Avocado Tuna Salad Wraps",
      tagline: "Tuna at $0.98 a can plus on-sale mango and avocado — bright, no-cook lunch.",
      serves: 3,
      cook_time: "12 min",
      method: "No-cook",
      total_cost: 15.66,
      per_serving: 5.22,
      ingredients: [
        { name: "Chunk Light Tuna (×2 cans)", qty: "2 cans", price: 1.96, on_sale: true },
        { name: "Caribbean Avocado", qty: "1", price: 3.99, on_sale: true },
        { name: "Ataulfo Mango", qty: "1", price: 0.94, on_sale: true },
        { name: "Grape Tomatoes (½ pint)", qty: "½ pint", price: 3.25, on_sale: true },
        { name: "English Cucumber (1 of 3-pack)", qty: "1", price: 0.94, on_sale: true },
        { name: "Jalapeno Pepper", qty: "1", price: 0.44, on_sale: true },
        { name: "Green Onion (½ bunch)", qty: "½ bunch", price: 0.49, on_sale: true },
        { name: "Cilantro (½ bunch)", qty: "½ bunch", price: 0.49, on_sale: true },
        { name: "Live Lettuce (for wraps)", qty: "1 head", price: 2.66, on_sale: true },
        { name: "Pantry: lime juice, olive oil, salt, pepper", qty: "—", price: 0.50, on_sale: false },
      ],
      instructions: [
        "Drain tuna thoroughly and flake into a large bowl.",
        "Dice avocado, mango, tomatoes, and cucumber. Mince jalapeno and slice green onions.",
        "Combine everything in the bowl with cilantro. Drizzle with lime juice and olive oil.",
        "Toss gently to combine without mashing the avocado. Season generously with salt and pepper.",
        "Spoon into lettuce cups and serve immediately."
      ],
      tip: "For a heartier version, serve over couscous or stir in a spoonful of the on-sale guacamole."
    },
    {
      id: "m7",
      meal_type: "Breakfast",
      day: "Sunday",
      name: "Breakfast Frittata with Bacon, Peppers & Cheddar",
      tagline: "Great for Sunday brunch or meal-prep breakfast for the whole week.",
      serves: 5,
      cook_time: "35 min",
      method: "Stovetop + Oven",
      total_cost: 17.95,
      per_serving: 3.59,
      ingredients: [
        { name: "Free Range Eggs (×8 from dozen)", qty: "8 eggs", price: 5.29, on_sale: true },
        { name: "Thick Cut Bacon (5 strips)", qty: "5 strips", price: 2.49, on_sale: true },
        { name: "Red Pepper", qty: "1", price: 2.11, on_sale: true },
        { name: "Orange Greenhouse Pepper", qty: "1", price: 2.11, on_sale: true },
        { name: "Green Onion (½ bunch)", qty: "½ bunch", price: 0.49, on_sale: true },
        { name: "Shredded Old Cheddar", qty: "1 pkg", price: 4.88, on_sale: true },
        { name: "Fresh Garlic", qty: "2 cloves", price: 0.22, on_sale: true },
        { name: "2% Milk", qty: "¼ cup", price: 0.31, on_sale: true },
        { name: "Salt & pepper", qty: "—", price: 0.05, on_sale: false },
      ],
      instructions: [
        "Preheat oven to 375°F. Cook bacon in an oven-safe 10-inch skillet until crisp; remove, crumble, leave fat in pan.",
        "Sauté diced peppers and garlic in the same pan over medium heat, 3 min. Add green onions, cook 1 min more.",
        "Whisk eggs with milk, salt, and pepper in a bowl.",
        "Pour eggs over vegetables. Scatter bacon crumbles and half the cheese on top.",
        "Cook undisturbed on stovetop until edges set, 3–4 min. Transfer skillet to oven.",
        "Bake 10–12 min until centre is just set. Add remaining cheese for last 2 min. Rest 5 min before slicing."
      ],
      tip: "Frittata keeps well in the fridge for 4 days — reheat individual slices for 60 seconds in the microwave."
    },
    {
      id: "m8",
      meal_type: "Dinner",
      day: "Saturday",
      name: "Chickpea, Tomato & Lentil Curry",
      tagline: "Every spice in this pot is on sale. Total cost under $12 for 5 servings.",
      serves: 5,
      cook_time: "40 min",
      method: "Stovetop",
      total_cost: 11.75,
      per_serving: 2.35,
      ingredients: [
        { name: "Chickpeas canned (×2)", qty: "2 cans", price: 2.54, on_sale: true },
        { name: "Lentils (1 cup from bag)", qty: "1 cup", price: 0.60, on_sale: true },
        { name: "Crushed Tomatoes (canned)", qty: "1 can", price: 1.79, on_sale: true },
        { name: "Diced Tomatoes (canned)", qty: "1 can", price: 1.79, on_sale: true },
        { name: "Red Onion (from 3 lb bag)", qty: "1", price: 1.33, on_sale: true },
        { name: "Fresh Garlic", qty: "1 head", price: 0.22, on_sale: true },
        { name: "Fresh Ginger", qty: "1 knob", price: 0.46, on_sale: true },
        { name: "Madras Curry Powder", qty: "1 tbsp", price: 0.16, on_sale: true },
        { name: "Garam Masala", qty: "1 tsp", price: 0.11, on_sale: true },
        { name: "Organic Ground Turmeric", qty: "1 tsp", price: 0.06, on_sale: true },
        { name: "Organic Ground Cumin", qty: "1 tsp", price: 0.06, on_sale: true },
        { name: "Chicken or Vegetable Broth", qty: "1 can", price: 1.25, on_sale: true },
        { name: "Couscous (1 cup from pkg)", qty: "1 cup", price: 1.08, on_sale: true },
        { name: "Pantry: oil, salt, optional spinach", qty: "—", price: 0.30, on_sale: false },
      ],
      instructions: [
        "Sauté diced red onion in oil over medium heat until golden, 6–8 min.",
        "Add minced garlic and grated ginger; cook 1 min. Add all dry spices and toast 30 seconds until fragrant.",
        "Add crushed tomatoes and diced tomatoes. Stir well and simmer 5 min.",
        "Add drained chickpeas, rinsed lentils, and broth. Bring to a boil, reduce to low, simmer 20 min until lentils are soft.",
        "Prepare couscous per package directions (usually just add boiling water and let sit 5 min).",
        "Taste curry and adjust salt. Stir in fresh spinach if using. Serve over couscous with a dollop of sour cream."
      ],
      tip: "This freezes beautifully — portion into containers for the easiest weekday lunches."
    },
  ],
  grocery_list: [
    {
      section: "Produce",
      items: [
        { name: "Russet Potatoes, 20 lb bag", qty: "1 bag", price: 8.48, used_in: "Recipes 1 & 4" },
        { name: "Colossal Fresh Garlic", qty: "3 heads", price: 0.66, used_in: "Recipes 1–8" },
        { name: "Fresh Ginger", qty: "2 knobs", price: 0.92, used_in: "Recipes 2, 3, 8" },
        { name: "Chinese Napa Cabbage", qty: "1 head", price: 3.57, used_in: "Recipe 2" },
        { name: "Shanghai Bok Choy", qty: "1 bag (3–4 heads)", price: 4.06, used_in: "Recipe 3" },
        { name: "Snap Peas", qty: "1 bag", price: 2.88, used_in: "Recipe 2" },
        { name: "Snow Peas", qty: "1 bag", price: 2.88, used_in: "Recipe 2" },
        { name: "Whole Cremini Mushrooms", qty: "2 pkgs", price: 9.00, used_in: "Recipes 2 & 4" },
        { name: "Greenhouse Pepper, Orange (×2)", qty: "2", price: 4.22, used_in: "Recipes 2 & 7" },
        { name: "Red Pepper", qty: "1", price: 2.11, used_in: "Recipe 7" },
        { name: "Grape Tomatoes", qty: "1 pint", price: 6.50, used_in: "Recipe 6" },
        { name: "English Cucumber 3-pack", qty: "1 pack", price: 2.82, used_in: "Recipe 6" },
        { name: "Jalapeno Peppers", qty: "3", price: 1.32, used_in: "Recipes 2, 5, 6" },
        { name: "Rapini", qty: "1 bunch", price: 1.99, used_in: "Recipe 5" },
        { name: "Green Onion", qty: "1 bunch", price: 0.99, used_in: "Recipes 2, 6, 7" },
        { name: "Red Onions, 3 lb bag", qty: "1 bag", price: 3.99, used_in: "Recipes 4 & 8" },
        { name: "Chinese Red Carrot (×2)", qty: "2", price: 1.08, used_in: "Recipe 4" },
        { name: "Cilantro", qty: "1 bunch", price: 0.99, used_in: "Recipe 6" },
        { name: "Live Lettuce Green", qty: "1 head", price: 2.66, used_in: "Recipe 6" },
        { name: "Caribbean Avocado", qty: "1", price: 3.99, used_in: "Recipe 6" },
        { name: "Ataulfo Mango", qty: "1", price: 0.94, used_in: "Recipe 6" },
      ]
    },
    {
      section: "Meat",
      items: [
        { name: "Pork Back Ribs (Honey Garlic or BBQ)", qty: "1 rack", price: 8.99, used_in: "Recipe 1" },
        { name: "Sirloin Tip Steak (~450g)", qty: "~450g pkg", price: 7.17, used_in: "Recipe 2" },
        { name: "Chicken Drumsticks Club Pack", qty: "1 pack", price: 9.09, used_in: "Recipe 3" },
        { name: "Beef Stew Meat (~700g)", qty: "~700g pkg", price: 12.68, used_in: "Recipe 4" },
        { name: "Italian Pork Sausages (Hot or Mild)", qty: "1 pack (4 links)", price: 6.49, used_in: "Recipe 5" },
        { name: "Thick Cut Bacon", qty: "1 pack", price: 5.97, used_in: "Recipe 7" },
        { name: "Chunk Light Tuna (×2 cans)", qty: "2 cans", price: 1.96, used_in: "Recipe 6" },
      ]
    },
    {
      section: "Dairy & Eggs",
      items: [
        { name: "Free Range Eggs (dozen)", qty: "1 dozen", price: 7.94, used_in: "Recipe 7" },
        { name: "2% Partly Skimmed Milk", qty: "1 jug", price: 5.00, used_in: "Recipe 7" },
        { name: "Shredded Old Cheddar", qty: "1 pkg", price: 4.88, used_in: "Recipe 7" },
        { name: "Parmesan Shredded Cheese", qty: "1 pkg", price: 5.99, used_in: "Recipe 5" },
        { name: "Sour Cream 18%", qty: "1 tub", price: 2.99, used_in: "Recipe 8 (topping)" },
      ]
    },
    {
      section: "Canned Goods & Broth",
      items: [
        { name: "Diced Tomatoes", qty: "2 cans", price: 3.58, used_in: "Recipes 4 & 8" },
        { name: "Crushed Tomatoes", qty: "1 can", price: 1.79, used_in: "Recipe 8" },
        { name: "Chickpeas", qty: "2 cans", price: 2.54, used_in: "Recipe 8" },
        { name: "Beef Broth", qty: "2 cans", price: 3.38, used_in: "Recipe 4" },
        { name: "Chicken or Vegetable Broth", qty: "2 cans", price: 2.50, used_in: "Recipes 3 & 8" },
      ]
    },
    {
      section: "Dry Goods",
      items: [
        { name: "Lentils", qty: "1 bag", price: 1.79, used_in: "Recipe 8" },
        { name: "Couscous, Medium", qty: "1 pkg", price: 3.25, used_in: "Recipe 8" },
      ]
    },
    {
      section: "Condiments & Syrup",
      items: [
        { name: "100% Pure Maple Syrup", qty: "1 bottle", price: 5.00, used_in: "Recipes 1 & 3" },
      ]
    },
    {
      section: "Spices & Seasonings",
      items: [
        { name: "Organic Smoked Paprika", qty: "1 jar", price: 2.79, used_in: "Recipe 1 — skip if stocked" },
        { name: "Organic Garlic Powder", qty: "1 jar", price: 2.79, used_in: "Recipe 1 — skip if stocked" },
        { name: "Organic Rosemary Leaves", qty: "1 jar", price: 2.79, used_in: "Recipes 1 & 4 — skip if stocked" },
        { name: "Organic Thyme Leaves", qty: "1 jar", price: 2.79, used_in: "Recipe 4 — skip if stocked" },
        { name: "Montreal Chicken Seasoning", qty: "1 jar", price: 4.97, used_in: "Recipe 3" },
        { name: "Organic Italian Seasoning", qty: "1 jar", price: 2.79, used_in: "Recipe 5 — skip if stocked" },
        { name: "Madras Curry Powder (Mild)", qty: "1 jar", price: 3.75, used_in: "Recipe 8" },
        { name: "Garam Masala", qty: "1 jar", price: 5.50, used_in: "Recipe 8" },
        { name: "Organic Ground Turmeric", qty: "1 jar", price: 2.79, used_in: "Recipe 8 — skip if stocked" },
        { name: "Organic Ground Cumin", qty: "1 jar", price: 2.79, used_in: "Recipe 8 — skip if stocked" },
      ]
    },
    {
      section: "Pantry Check (buy if needed)",
      items: [
        { name: "Olive oil / neutral cooking oil", qty: "—", price: 0, used_in: "All savoury recipes" },
        { name: "Soy sauce", qty: "—", price: 0, used_in: "Recipes 1, 2, 3" },
        { name: "Sesame oil", qty: "—", price: 0, used_in: "Recipe 2" },
        { name: "White rice or jasmine rice", qty: "—", price: 0, used_in: "Recipes 2, 3" },
        { name: "Pasta (orecchiette or rigatoni, 350g)", qty: "350g", price: 2.00, used_in: "Recipe 5" },
        { name: "Flour, tomato paste, Dijon mustard", qty: "—", price: 0, used_in: "Recipes 4, 5" },
        { name: "Salt, pepper, chili flakes, cornstarch, lime", qty: "—", price: 0, used_in: "Various" },
      ]
    }
  ]
};
